module.exports = __webpack_public_path__ + "static/img/linkedin.fd0d554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floating-button/linkedin.png
// module id = /Yid
// module chunks = 46